import { Flex, Link } from '@raystack/apsara';

import { RetrievalResponse } from '@src/clients/seeker/api';

import styles from './Link.module.css';

interface LinkCompProps {
  link: RetrievalResponse;
}

export const LinkComp: React.FC<LinkCompProps> = ({ link }) => {
  // Extract the base URL to get the favicon
  const faviconUrl = `https://www.google.com/s2/favicons?sz=64&domain_url=${link.url}`;
  const parsedLabel =
    link.text || new URL(link.url).hostname.replace('www.', '');

  return (
    <Flex direction='column' className={styles.linkUICompLayout}>
      <Flex justify='center' align='center' className={styles.chip}>
        <img src={faviconUrl} alt='Link Icon' className={styles.favIcon} />
        <Link
          size='mini'
          external
          href={link.url}
          variant='secondary'
          data-test-id='linkAtribute'
        >
          {parsedLabel}
        </Link>
      </Flex>
    </Flex>
  );
};
